const dashboards = [
  {
    valor:"Otro",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10periodo2000a2021sinembarazos/Dashboard1"
    },
  {
    valor:"Embarazo, parto y puerperio",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10periodo2000a2021embarazo/Dashboard1"
  }

  
];

export default dashboards;
